import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ViewCell} from '@mominsamir/ngx-smart-table';
import {NbTrigger} from '@nebular/theme';

export interface CustomCellIcon {
    iconName: string;
    iconClass?: string;
    containerStyle?: string;
    position?: IconPosition;
    pack: 'engin' | 'eva';
}

export interface CustomCellTooltip {
    message: string;
    innerHTML: string;
    trigger: NbTrigger;
}

export enum IconPosition {
    LEFT = 'left',
    RIGHT = 'right',
}

@Component({
    selector: 'ngx-text-with-icon-cell',
    template: `
        <div>
            <div
                *ngIf="
                    icon?.position === IconPosition.LEFT || icon?.position === IconPosition.RIGHT;
                    else defaultTemplate
                "
                class="cell-content"
            >
                <!-- Left Icon -->
                <ng-container *ngIf="icon?.position === IconPosition.LEFT">
                    <ng-container *ngIf="tooltip; else noTooltipLeft">
                        <div [ngClass]="icon?.containerStyle ? icon.containerStyle : ''">
                            <nb-icon
                                [icon]="icon?.iconName"
                                [nbPopover]="tooltipTemplate"
                                [nbPopoverTrigger]="tooltip?.trigger"
                                [ngClass]="(icon?.iconClass || '') + ' tooltip-icon'"
                                [pack]="icon?.pack ? icon.pack : 'eva'"
                            ></nb-icon>
                        </div>
                    </ng-container>
                    <ng-template #noTooltipLeft>
                        <div [ngClass]="icon?.containerStyle ? icon.containerStyle : ''">
                            <nb-icon
                                [icon]="icon?.iconName"
                                [ngClass]="icon?.iconClass ? icon.iconClass : ''"
                                [pack]="icon?.pack ? icon.pack : 'eva'"
                            ></nb-icon>
                        </div>
                    </ng-template>
                    <span class="icon-left">{{ value }}</span>
                </ng-container>

                <!-- Right Icon -->
                <ng-container *ngIf="icon?.position === IconPosition.RIGHT">
                    <span class="icon-right">{{ value }}</span>
                    <ng-container *ngIf="tooltip; else noTooltipRight">
                        <div [ngClass]="icon?.containerStyle ? icon.containerStyle : ''">
                            <nb-icon
                                [icon]="icon?.iconName"
                                [nbPopover]="tooltipTemplate"
                                [nbPopoverTrigger]="tooltip?.trigger"
                                [ngClass]="(icon?.iconClass || '') + ' tooltip-icon'"
                                [pack]="icon?.pack ? icon.pack : 'eva'"
                            ></nb-icon>
                        </div>
                    </ng-container>
                    <ng-template #noTooltipRight>
                        <div [ngClass]="icon?.containerStyle ? icon.containerStyle : ''">
                            <nb-icon
                                [icon]="icon?.iconName"
                                [ngClass]="icon?.iconClass ? icon.iconClass : ''"
                                [pack]="icon?.pack ? icon.pack : 'eva'"
                            ></nb-icon>
                        </div>
                    </ng-template>
                </ng-container>
            </div>

            <!-- Default template without icon -->
            <ng-template #defaultTemplate>
                <div class="cell-content">
                    <span>{{ value }}</span>
                </div>
            </ng-template>
        </div>

        <!-- Tooltip template -->
        <ng-template #tooltipTemplate>
            <div class="p-2">
                <span *ngIf="tooltip?.message" class="tooltip-message">
                    {{ tooltip?.message }}
                </span>
                <span *ngIf="tooltip?.innerHTML" class="tooltip-message" [innerHTML]="tooltip?.innerHTML"></span>
            </div>
        </ng-template>
    `,
    styleUrls: ['./text-with-icon-cell.component.scss'],
})
export class TextWithIconCellComponent implements ViewCell, OnInit {
    @Input() icon: CustomCellIcon;
    @Input() tooltip: CustomCellTooltip;
    @Input() value: any;
    @Input() rowData: any;
    @Output() getRowData: EventEmitter<any> = new EventEmitter();
    @Output() getValue: EventEmitter<any> = new EventEmitter();
    IconPosition = IconPosition;

    ngOnInit(): void {
        this.getRowData.emit(this.rowData);
        this.getValue.emit(this.value);
    }
}
